import { useMemo } from 'react';
import { FormProvider } from 'react-hook-form';
import { FilterDrawer, RhfSelect } from '@core/components';
import { useFilterDrawer } from '@core/hooks/useFilterDrawer';
import { getOptions } from '@core/utils/enum';
import { OrderStatus } from '../enum/orderStatus';
import { VestmentCategory } from '../enum/vestmentCategory';
import { EMPTY_ORDER_FILTERS, type OrderFilters } from '../utils/order';

interface OrderFilterDrawerProps {
  open: boolean;
  filters: OrderFilters;
  onApply: (filters: OrderFilters) => void;
  onClear: () => void;
  onClose: () => void;
}

const OrderFilterDrawer: React.FC<OrderFilterDrawerProps> = ({
  open,
  filters,
  onApply,
  onClear,
  onClose,
}) => {
  const { methods, handleApply, handleClear } = useFilterDrawer({
    open,
    filters,
    emptyFilters: EMPTY_ORDER_FILTERS,
    onApply,
    onClear,
  });

  const statusOptions = useMemo(
    () => [
      { value: '', label: 'All statuses' },
      { value: 'open', label: 'Open' },
      { value: 'closed', label: 'Closed' },
      ...getOptions(OrderStatus),
    ],
    []
  );

  const itemOptions = useMemo(
    () => [{ value: '', label: 'All items' }, ...getOptions(VestmentCategory)],
    []
  );

  return (
    <FormProvider {...methods}>
      <FilterDrawer
        open={open}
        title="Filter orders"
        onApply={handleApply}
        onClear={handleClear}
        onClose={onClose}
      >
        <RhfSelect<OrderFilters>
          name="status"
          label="Status"
          options={statusOptions}
        />
        <RhfSelect<OrderFilters>
          name="category"
          label="Item"
          options={itemOptions}
        />
      </FilterDrawer>
    </FormProvider>
  );
};

export default OrderFilterDrawer;
